// src/utils/cardUtils.ts
import { CardCustomization } from "../types/card.types";
import { ArchetypeId } from "../constants/archetypes";

export const initializeCustomization = (template: any, user: any): CardCustomization => ({
  recipientType: template.recipientType,
  recipientName: "",
  recipientImage: null,
  senderName: user?.name || "",
  senderEmail: user?.email || "",
  title: template.preview.title,
  message: template.preview.message,
  personalNote: template.preview.personalNote || "",
  memory: template.preview.memory || "",
  insideJoke: template.preview.insideJoke || "",
  loadingText: "Preparing your surprise...",
  theme: template.theme.id,
  primaryColor: template.theme.primaryColor,
  secondaryColor: template.theme.secondaryColor,
  accentColor: template.theme.accentColor,
  fontFamily: template.theme.fontFamily,
  includeBouquet: false,
  bouquetAmount: 0,
  petals: 0,
  includeHeartParticles: false,
  includeSparkles: false,
  status: "draft",

  privacyMode: "standard_private",
  requiresPasscode: false,
  passcode: "",
  deleteAfterOpen: false,
});

// New function for archetype-based initialization
export const initializeCustomizationFromArchetype = (
  template: any,
  user: any,
  archetype: ArchetypeId
): CardCustomization => {
  const base = initializeCustomization(template, user);

  // Add archetype-specific customizations
  return {
    ...base,
    archetype,
    // You can add more archetype-specific defaults here
  };
};
